export default __webpack_public_path__ + "static/media/WeeklySalesIcon.40df8dd4.svg";